module.exports = __webpack_public_path__ + "img/analytics.f1dc48c5.svg";